import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';


// Runtime fallback for development/old HTML. The post-build script also adds
// these directives to the initial HTML, before any JavaScript executes.
for (const name of ['robots', 'googlebot', 'viewport']) {
  const tag = document.querySelector(`meta[name="${name}"]`) || document.createElement('meta');
  tag.name = name;
  tag.content = name === 'viewport' ? 'width=device-width, initial-scale=1' : 'noindex, nofollow, noarchive, nosnippet, noimageindex';
  if (!tag.parentNode) document.head.appendChild(tag);
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    <App />
  // </React.StrictMode>
);